'use client';

import * as React from 'react';
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

export interface EnergyMonthlyPoint {
	month: string;
	immessa: number;
	prelevata: number;
	condivisa: number;
}

/** Monthly injected/withdrawn/shared energy bars (last months). */
const EnergyMonthlyChart = ({ data }: { data: EnergyMonthlyPoint[] }) => (
	<ResponsiveContainer width="100%" height={220}>
		<BarChart data={data}>
			<XAxis
				dataKey="month"
				tick={{ fontSize: 11, fill: '#64748b' }}
				tickLine={false}
				axisLine={false}
			/>
			<YAxis
				tick={{ fontSize: 11, fill: '#64748b' }}
				tickLine={false}
				axisLine={false}
				unit=" kWh"
				width={55}
			/>
			<Tooltip
				contentStyle={{
					background: '#0f1f35',
					border: '1px solid #1a3a5c',
					borderRadius: 8,
					fontSize: 13,
				}}
				labelStyle={{ color: '#e2e8f0' }}
			/>
			<Legend iconSize={8} wrapperStyle={{ fontSize: 12 }} />
			<Bar dataKey="immessa" name="Immessa" fill="var(--color-accent)" radius={[3, 3, 0, 0]} />
			<Bar dataKey="prelevata" name="Prelevata" fill="#f59e0b" radius={[3, 3, 0, 0]} />
			<Bar dataKey="condivisa" name="Condivisa" fill="#10b981" radius={[3, 3, 0, 0]} />
		</BarChart>
	</ResponsiveContainer>
);
EnergyMonthlyChart.displayName = 'EnergyMonthlyChart';

export { EnergyMonthlyChart };
